import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateBatteryPrice } from "./battery-price-dependents"
import type {
  BatteryProposalIncentivesDto,
  UpdateBatteryProposalIncentivesDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useUpdateBatteryProposalIncentives(): UseMutationResult<
  BatteryProposalIncentivesDto,
  unknown,
  { proposalId: string; body: UpdateBatteryProposalIncentivesDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.updateIncentives(proposalId, body),
    onSuccess: (incentives, { proposalId }) => {
      // The response is the canonical catalog after saving — adopt it as-is.
      queryClient.setQueryData(
        queryKeys.batteryProposal.incentives(proposalId),
        incentives,
      )
      // A Powur incentive selection or payee change stales the stored price
      // server-side, and saved incentives feed the financial summary.
      invalidateBatteryPrice(queryClient, proposalId)
    },
  })
}
